import { render, staticRenderFns } from "./select-from-class.vue?vue&type=template&id=518bf84a&"
import script from "./select-from-class.vue?vue&type=script&lang=js&"
export * from "./select-from-class.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports